'use client'

import React from 'react'
import { DictationDemoCard } from '../../components/landing/dictation-demo-card'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'

/**
 * 「換你試試看」。緊接在例子下方，示範卡的版面照抄例子框的左右結構——讀者剛看懂
 * 例子，馬上就知道這塊要做什麼。
 *
 * 上內距歸零：例子與這一塊是同一件事的兩半，中間只留一個 --section-space，
 * 不是兩個區塊之間的兩倍距離。
 */
export function DictationTryDemoSection() {
  return (
    <SiteSection trackingKey="try_demo" className="pt-0">
      <Reveal>
        <SectionHead
          titleKey="web:dictationPage.try.title"
          level={3}
          size="block"
          className="mb-(--gap-md)"
        />
      </Reveal>
      <DictationDemoCard />
    </SiteSection>
  )
}
